const competition = {
    number: "1/1",
    question: "Competition",
    description: `Find your spot in the market. Bring about which corner of
                            the market you occupy by plotting your company in 2 or 4
                            spaces. Use this graph to plot where your company is today,
                            and where it is headed. This will give your team clarity
                            over how you intend to achieve your vision, and who you're
                            competing against.`
}

export const questions = {
    competition: competition
}

const competitionVideo = {
    url: "https://www.dropbox.com/scl/fi/kopqpb57vyote72b7y0x0/28-Market-Trends.mp4?rlkey=0woci39ktml7s9q5ayiafqo7n&raw=1"
}

export const videos = {
    competitionVideo: competitionVideo,
}